import { render } from "./AddProductPage.vue?vue&type=template&id=afaa9c8c&ts=true"
import script from "./AddProductPage.vue?vue&type=script&lang=ts"
export * from "./AddProductPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__